module.exports = __webpack_public_path__ + "media/images/dummy-thumbnail1-5cce82a347710f709708dca6a713616e.jpg";